import React from "react";
import ReportItem from "./ReportItem";
import ReportItemDisplayNew from "./ReportItemDisplayNew";
import TagSearch from "./TagSearch";
import { formatDateAndTimeFromString } from "../util";
class Tests extends React.Component {
  state = {
    items: this.props.items,
    all_items: this.props.items,
    loading: true,
    filter_page_types: null,
    filter_notes: null,
    showTimeline: false,
  };
  doPageFilter = vals => {
    if (!vals || vals.length === 0) {
      this.setState({ filter_page_types: null });
    } else {
      this.setState({ filter_page_types: vals });
    }
  };
  doNotesFilter = vals => {
    if (!vals || vals.length === 0) {
      this.setState({ filter_notes: null });
    } else {
      this.setState({ filter_notes: vals });
    }
  };
  filterItems = () => {
    const { filter_notes, filter_page_types } = this.state;

    if (!filter_notes && !filter_page_types) {
      return this.state.items;
    }

    return this.state.items.filter(item => {
      let show = false;

      if (filter_page_types) {
        show = filter_page_types.includes(item.page_type);
      }

      if (filter_notes) {
        show = false;
      }

      return show;
    });
  };
  getItemAnchorId = item => {
    const date = item.start_date || item.end_date || item.id;
    return `test-${String(date).replace(/[:.]/g, "-")}`;
  };
  formatDateTime = dateStr => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return Number.isNaN(d.getTime()) ? dateStr : d.toLocaleString();
  };
  render() {
    const items = this.filterItems();
    const { showTimeline } = this.state;
    return (
      <>
        {items && items.length > 0 && (
          <div
            className={`fixed top-0 right-0 mt2 mr2 bg-white br2 ba b--light-gray shadow-2 z-999 ${
              showTimeline ? "w5 pa2" : "w2 pa1"
            } overflow-y-scroll`}
            style={{ maxHeight: "70vh" }}
          >
            <div
              className="flex justify-between bg-white"
              style={{ position: "sticky", top: 0, zIndex: 1 }}
            >
              {showTimeline && <strong>Timeline</strong>}
              <button
                onClick={() =>
                  this.setState({ showTimeline: !this.state.showTimeline })
                }
                className="bn bg-transparent pointer f6"
                aria-label={showTimeline ? "Minimize" : "Expand"}
                title={showTimeline ? "Minimize" : "Expand"}
              >
                {showTimeline ? "–" : "+"}
              </button>
            </div>
            {showTimeline && (
              <ul className="list pl0 ma0 mt2">
                {items.map(item => {
                  const anchorId = this.getItemAnchorId(item);
                  const displayDate =
                    item.start_date || item.end_date
                      ? `${item.start_date ? "Start: " + formatDateAndTimeFromString(item.start_date) : ""}${
                          item.start_date && item.end_date ? " | " : ""
                        }${item.end_date ? "End: " + formatDateAndTimeFromString(item.end_date) : ""}`
                      : `Test ${item.id}`;
                  return (
                    <li key={item.id} className="mb2">
                      <a
                        href={`#${anchorId}`}
                        className="dark-red no-underline"
                      >
                        {displayDate}
                      </a>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        )}
        <div>
          <div className="dib w-25">
            <TagSearch
              options={this.props.page_types.map(p => ({ label: p, value: p }))}
              placeholder="Filter by page type"
              callback={this.doPageFilter}
            />
          </div>
        </div>
        {items.map((d, i) => (
          <div key={d.id} id={this.getItemAnchorId(d)}>
            {d.screenshots && d.screenshots[0] && d.screenshots[0].notes ? (
              <ReportItemDisplayNew
                d={d}
                isAdminPage={true}
                urlCompany="admin"
                userCompany="admin"
                byModule={false}
                i={i}
              />
            ) : (
              <ReportItem d={d} isAdmin={true} />
            )}
          </div>
        ))}
      </>
    );
  }
}

export default Tests;
